export class FlagResolver {
    static ContainsFlag(flagToSearch: number, flags: number) {
        return (flagToSearch & flags) === flagToSearch;
    }
}